import { SvgIcon, SvgIconProps } from "@mui/material";
import { IconAppleSvg } from "src/components/icons";

export const IconApple = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <IconAppleSvg />
    </SvgIcon>
);
